module.exports = __webpack_public_path__ + "img/icon-stop-navi.0989f5e4.png";